module.exports = __webpack_public_path__ + "img/Untitled-3.91ab3c0c.png";